<template>

  <div class="w-2/3 no-gutter items-center justify-center" style="margin-left: auto; margin-right: auto;">
     <vx-card :collapse-action="true"  style="background-color: #C0C5C1" class="mt-3">
        <vs-row vs-type="flex" vs-justify="center" v-if="isTemAlgumaPermissao">            
            <vs-col vs-w="6" v-if="isTemAlgumaPermissaoColuna1">                
                <div class="ml-4 mb-4" >
                    <div class="flex items-center" @click="redirecionar('/controle-pneus/almoxarifado/pesquisar')" v-if="verificarPermissao('menuPneu_Almoxarifados')">
                        <div> <img src="@/assets/concept/iconesToolbar/almoxarifado.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Almoxarifados</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/fabricante-pneu/pesquisar')" v-if="verificarPermissao('menuPneu_Fabricante')">
                        <div> <img src="@/assets/concept/iconesToolbar/fornecedores.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Fabricantes</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/bandas-rodagem-pneu/pesquisar')" v-if="verificarPermissao('menuPneu_BandaRodagem')">
                        <div> <img src="@/assets/concept/iconesToolbar/bandaRodagem.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Banda de Rodagem</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/dimensoes-pneu/pesquisar')" v-if="verificarPermissao('menuPneu_Dimensoes')">
                        <div> <img src="@/assets/concept/iconesToolbar/medidas.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Dimensões</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/modelos-pneu/pesquisar')" v-if="verificarPermissao('menuPneu_Modelos')">
                        <div> <img src="@/assets/concept/iconesToolbar/fabricantes.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Modelos</h6></div>
                    </div>
                </div>
            </vs-col>
            <vs-col vs-w="6" v-if="isTemAlgumaPermissaoColuna2">          
                <div class="ml-4 mb-4" >      
                    <div class="flex items-center" @click="redirecionar('/controle-pneus/motivo-sucateamento/pesquisar')" v-if="verificarPermissao('menuPneu_MotivoSucateamento')">
                        <div> <img src="@/assets/concept/iconesToolbar/pneuSucata.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Motivo Sucateamento</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/pneus/pesquisar')" v-if="verificarPermissao('menuPneu_Pneu')">
                        <div> <img src="@/assets/concept/iconesToolbar/pneu.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Pneu</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/movimentacoes-pneus')" v-if="verificarPermissao('menuPneu_MovimentacaoPneu')">
                        <div> <img src="@/assets/concept/iconesToolbar/movimentacaoPneu.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Movimentação Pneu</h6></div>
                    </div>
                    <div class="flex items-center mt-2" @click="redirecionar('/controle-pneus/inspecoes-pneus')" v-if="verificarPermissao('menuPneu_InspecaoPneu')">
                        <div> <img src="@/assets/concept/iconesToolbar/afericaoPneu.png" alt="content-img" width="30" height="30"> </div>
                        <div class="ml-4"> <h6 class="mb-2" style="color:#574B60; text-transform: uppercase;">Inspeção Pneu</h6></div>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" v-if="!isTemAlgumaPermissao">            
            <vs-col vs-w="12" >  
                <h3 v-if="!isTemAlgumaPermissao" class="w-full text-center text-danger"> Sem permissão para acessar essa funcionalidade. </h3>
                <h3 v-if="!isTemAlgumaPermissao" class="w-full text-center text-danger"> Entre em contato com {{this.$store.state.AppActiveUser.nomeCentral}} {{this.$store.state.AppActiveUser.telefoneCentral}} para contratar.  </h3>
            </vs-col>
        </vs-row>
     </vx-card>    
</div>    
</template>
<script>

export default {   
  data() {
    return {
      login: '' 
    }
  },
  computed:{
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },
    isVersaoPro() {
        return this.$store.getters.isVersaoPro;
    },
    isVersaoBasic(){
        return this.$store.getters.isVersaoBasic;
    },
    isTemAlgumaPermissao() {
         return this.isTemAlgumaPermissaoColuna1 || this.isTemAlgumaPermissaoColuna2;
    },
    isTemAlgumaPermissaoColuna1() {
        if (this.isAcessoMaster) {
            return true;
        }

        if (this.isVersaoBasic) {
            return false;
        }

        if (this.isAcessoIndividual) {
            return false;
        }

        return this.$store.state.AppActiveUser.temControlePneus && (this.$store.state.AppActiveUser.permissoes.menuPneu_Almoxarifados ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_Fabricante ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_Dimensoes ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_Modelos ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_BandaRodagem);
    },
    isTemAlgumaPermissaoColuna2() {
        if (this.isAcessoMaster) {
            return true;
        }

        if (this.isVersaoBasic) {
            return false;
        }

        if (this.isAcessoIndividual) {
            return false;
        }

        return this.$store.state.AppActiveUser.temControlePneus && ( this.$store.state.AppActiveUser.permissoes.menuPneu_MotivoSucateamento  ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_Pneu ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_MovimentacaoPneu ||
                this.$store.state.AppActiveUser.permissoes.menuPneu_InspecaoPneu );
    }
  },
  methods: {
    redirecionar(opcao) {
        this.$router.push({ path: opcao });
    },   
    verificarPermissao(modulo) {
         if (!this.$store.state.AppActiveUser.temControlePneus) {
             return false;
         } 

        if (this.isAcessoMaster) {            
            if (this.isVersaoBasic) {               
                return false;
            } else if (this.isVersaoPro) {                                
                return true;
            }         
        } else if (this.isAcessoGrupo) {
            if (this.isVersaoBasic) {                
                return false;
            } else if (this.isVersaoPro) {
                if (modulo === "menuPneu_Almoxarifados") { return this.$store.state.AppActiveUser.permissoes.menuPneu_Almoxarifados }
                if (modulo === "menuPneu_Fabricante") { return this.$store.state.AppActiveUser.permissoes.menuPneu_Fabricante }
                if (modulo === "menuPneu_Dimensoes") { return this.$store.state.AppActiveUser.permissoes.menuPneu_Dimensoes }
                if (modulo === "menuPneu_Modelos") { return this.$store.state.AppActiveUser.permissoes.menuPneu_Modelos }
                if (modulo === "menuPneu_BandaRodagem") { return this.$store.state.AppActiveUser.permissoes.menuPneu_BandaRodagem }
                if (modulo === "menuPneu_MotivoSucateamento") { return this.$store.state.AppActiveUser.permissoes.menuPneu_MotivoSucateamento }
                if (modulo === "menuPneu_Pneu") { return this.$store.state.AppActiveUser.permissoes.menuPneu_Pneu }
                if (modulo === "menuPneu_MovimentacaoPneu") { return this.$store.state.AppActiveUser.permissoes.menuPneu_MovimentacaoPneu }
                if (modulo === "menuPneu_InspecaoPneu") { return this.$store.state.AppActiveUser.permissoes.menuPneu_InspecaoPneu }
                return true;
            } 
        } else if (this.isAcessoIndividual) {
            return false;
        }
        
        return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.card-item {
    &:hover {
        transform: translateY(-5px);              
    }
}
</style>